import styled from 'styled-components'
import DefaultTooltip from '@material-ui/core/Tooltip'

export const Tooltip = styled(DefaultTooltip)``

export const Container = styled.div``
